/**
 * API client for the EPAR Document Viewer endpoints.
 *
 * Thin re-export layer over `createViewerApi.ts` — same shape as
 * `viewerApi.ts` (SBA) but bound to the `/epar` prefix.  Pre-existing
 * call sites keep working unchanged.
 */
import { eparApi } from './createViewerApi';

export type {
  SectionRefMatch,
  ResolveSectionRefResponse,
} from './createViewerApi';
export { buildImageUrl } from './createViewerApi';

export const fetchTOC = eparApi.fetchTOC;
export const fetchPages = eparApi.fetchPages;
export const fetchTextSpans = eparApi.fetchTextSpans;
export const fetchBatchTextSpans = eparApi.fetchBatchTextSpans;
export const fetchChunk = eparApi.fetchChunk;
export const fetchChunksBatch = eparApi.fetchChunksBatch;
export const resolveSectionRef = eparApi.resolveSectionRef;
export const searchDocument = eparApi.searchDocument;
